import PropTypes from "prop-types"
import { useCallback } from "react"

import withGiftBundles from "areas/cart/hoc/with-gift-bundles"
import Checkbox from "components/ui/checkbox"
import Expand from "components/ui/expand"
import { isTestMode } from "helpers/application"
import { cn } from "styles/utils"

import GiftBundles from "./gift-bundles"

const GiftOptions = ({
  handleGiftBundle,
  item,
  selectedGiftBundle,
  source,
}) => {
  const giftBundleOptions = item.gift_bundle_options || []

  const handleToggleGift = useCallback(() => {
    if (!isTestMode) {
      dataLayer.push({ event: "expand-cart-line-item-gift-option" })
    }

    handleGiftBundle(selectedGiftBundle ? null : giftBundleOptions?.[0])
  }, [handleGiftBundle, giftBundleOptions, selectedGiftBundle])

  if (!giftBundleOptions.length) {
    return null
  }

  return (
    <section
      aria-describedby={`cart-line-item-gift-option-description-${item.id}`}
      aria-label="Gift Packaging Options"
      className={cn(
        source === "atc-modal"
          ? "bg-grey-100 mb-12 px-16 py-12"
          : "border-b-grey-20 border-b px-12 py-14"
      )}
    >
      <Checkbox
        aria-checked={!!selectedGiftBundle}
        aria-controls={`cart-line-item-gift-option-content-${item.id}`}
        checkboxClassName="rounded-full border-primary text-white aria-checked:bg-primary"
        checked={!!selectedGiftBundle}
        className="w-full flex-wrap items-center gap-8"
        data-cy={`cart-line-item-packaging-checkbox-${item.style_code}`}
        id={`cart-line-item-gift-option-heading-${item.id}`}
        onChange={handleToggleGift}
        role="switch"
      >
        <h3 className="text-16 font-semibold">Is This a Gift?</h3>
        <span
          className={cn(
            "text-14 basis-full font-medium",
            source === "atc-modal" && "sr-only"
          )}
          id={`cart-line-item-gift-option-description-${item.id}`}
        >
          Add a personalized card and gift wrap.
        </span>
      </Checkbox>
      <Expand
        aria-labelledby={`cart-line-item-gift-option-heading-${item.id}`}
        className={cn(
          source === "atc-modal" ? "pt-12" : "bg-grey-100 mt-16 w-full p-12"
        )}
        id={`cart-line-item-gift-option-content-${item.id}`}
        role="region"
        show={!!selectedGiftBundle}
      >
        <GiftBundles
          handleGiftBundle={handleGiftBundle}
          item={item}
          selectedGiftBundle={selectedGiftBundle}
        />
      </Expand>
    </section>
  )
}

GiftOptions.propTypes = {
  handleGiftBundle: PropTypes.func,
  item: PropTypes.object,
  selectedGiftBundle: PropTypes.object,
  source: PropTypes.string,
}

export default withGiftBundles(GiftOptions)
